// Events
export const CLICK_PRIVACY_POLICY_LINK = 'CLICK_PRIVACY_POLICY_LINK';
export const UNDO_DISMISSAL_STARTED = 'UNDO_DISMISSAL_STARTED';
export const UNDO_DISMISSAL_SUCCEEDED = 'UNDO_DISMISSAL_SUCCEEDED';
export const UNDO_DISMISSAL_FAILED = 'UNDO_DISMISSAL_FAILED';